var _rect, _path, _path2, _path3, _path4, _path5, _rect2, _path6, _path7, _path8;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgGrowthCup(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Component_127_1",
    "data-name": "Component 127 \\u2013 1",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.817,
    height: 49,
    viewBox: "0 0 35.817 49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3194",
    "data-name": "Rectangle 3194",
    width: 24.309,
    height: 3.35,
    rx: 1.675,
    transform: "translate(5.754 44.932)",
    fill: "#787681"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2651",
    "data-name": "Path 2651",
    d: "M332.307,469.5H328a.957.957,0,0,1,.957.957v1.436a.957.957,0,0,1-.957.957h4.307a.957.957,0,0,0,.957-.957v-1.436A.957.957,0,0,0,332.307,469.5Z",
    transform: "translate(-303.201 -424.568)",
    fill: "#57565c"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2652",
    "data-name": "Path 2652",
    d: "M159.957,389.5h16.652a.957.957,0,0,1,.957.957v6.7H159v-6.7A.957.957,0,0,1,159.957,389.5Z",
    transform: "translate(-150.375 -352.224)",
    fill: "#8b8893"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2653",
    "data-name": "Path 2653",
    d: "M302.307,389.5H298a.957.957,0,0,1,.957.957v6.7h4.307v-6.7A.957.957,0,0,0,302.307,389.5Z",
    transform: "translate(-276.072 -352.224)",
    fill: "#787681"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2654",
    "data-name": "Path 2654",
    d: "M183.953,294.5a10.807,10.807,0,0,0,.921,3.919,11.283,11.283,0,0,0,4.821,5.173H174a11.283,11.283,0,0,0,4.821-5.173,10.807,10.807,0,0,0,.921-3.919Z",
    transform: "translate(-163.939 -266.316)",
    fill: "#fddd5a"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2655",
    "data-name": "Path 2655",
    d: "M251.792,298.419a10.807,10.807,0,0,1-.921-3.919H248a10.807,10.807,0,0,0,.921,3.919,11.283,11.283,0,0,0,4.821,5.173h2.871A11.283,11.283,0,0,1,251.792,298.419Z",
    transform: "translate(-230.857 -266.316)",
    fill: "#fed030"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_3195",
    "data-name": "Rectangle 3195",
    width: 7.561,
    height: 3.35,
    rx: 1.675,
    transform: "translate(14.128 24.835)",
    fill: "#e07631"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2656",
    "data-name": "Path 2656",
    d: "M152.37,21.57a23.045,23.045,0,0,1-8.661,10.049h-2.871A22.817,22.817,0,0,1,130.466,9.054a1.811,1.811,0,0,1,1.8-1.554h20.025a1.811,1.811,0,0,1,1.8,1.554A23.056,23.056,0,0,1,152.37,21.57Z",
    transform: "translate(-124.366 -6.782)",
    fill: "#fddd5a"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2657",
    "data-name": "Path 2657",
    d: "M247.461,9.054a1.811,1.811,0,0,0-1.8-1.554h-4.307a1.811,1.811,0,0,1,1.8,1.554A22.81,22.81,0,0,1,233.5,31.142c.271.187.513.346.718.476h2.871A22.817,22.817,0,0,0,247.461,9.054Z",
    transform: "translate(-217.745 -6.782)",
    fill: "#fed030"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_2658",
    "data-name": "Path 2658",
    d: "M104.013,3.872a2.843,2.843,0,0,0-2.167-1H99.391c-.027-.241-.056-.475-.088-.7A2.54,2.54,0,0,0,96.8,0H76.772a2.54,2.54,0,0,0-2.506,2.171c-.032.224-.061.458-.088.7H71.724a2.848,2.848,0,0,0-2.811,3.3L69.451,9.5a14.975,14.975,0,0,0,10.9,12.085A24.4,24.4,0,0,0,83.5,24.428a2.391,2.391,0,0,0,.411,4.348,9.987,9.987,0,0,1-.81,3.035,10.575,10.575,0,0,1-4.355,4.748h-.289a1.677,1.677,0,0,0-1.675,1.675v5.981h-1.2a1.677,1.677,0,0,0-1.675,1.675v1.436A1.677,1.677,0,0,0,75.587,49H97.982a1.677,1.677,0,0,0,1.675-1.675V45.89a1.677,1.677,0,0,0-1.675-1.675h-1.2V38.233a1.677,1.677,0,0,0-1.675-1.675h-.289a10.575,10.575,0,0,1-4.355-4.748,9.987,9.987,0,0,1-.81-3.035,2.391,2.391,0,0,0,.411-4.348,24.4,24.4,0,0,0,3.155-2.838A14.975,14.975,0,0,0,104.119,9.5l.538-3.333A2.844,2.844,0,0,0,104.013,3.872Zm-33.145,5.4L70.33,5.944a1.413,1.413,0,0,1,1.394-1.637h2.338a23.561,23.561,0,0,0,1.97,10.771,23.185,23.185,0,0,0,2.515,4.339A13.545,13.545,0,0,1,70.868,9.276ZM97.982,45.65a.24.24,0,0,1,.239.239v1.436a.24.24,0,0,1-.239.239H75.587a.24.24,0,0,1-.239-.239V45.89a.24.24,0,0,1,.239-.239Zm-3.352-7.656h.481a.24.24,0,0,1,.239.239v5.981H78.219V38.233a.24.24,0,0,1,.239-.239H94.629Zm-2.3-1.436h-11.1A11.627,11.627,0,0,0,84.413,32.4a11.418,11.418,0,0,0,.931-3.494h2.88a11.417,11.417,0,0,0,.931,3.494,11.626,11.626,0,0,0,3.177,4.162ZM88.89,27.467H84.679a.957.957,0,0,1,0-1.914h.636c.022,0,.045,0,.067,0H88.89a.957.957,0,1,1,0,1.914Zm-.879-3.35H85.558a22.454,22.454,0,0,1-8.214-9.62A22.288,22.288,0,0,1,75.688,2.372a1.1,1.1,0,0,1,1.085-.937H96.8a1.1,1.1,0,0,1,1.084.937A22.287,22.287,0,0,1,96.225,14.5,22.454,22.454,0,0,1,88.011,24.117ZM103.239,5.944,102.7,9.276a13.545,13.545,0,0,1-7.679,10.141,23.183,23.183,0,0,0,2.515-4.339,23.561,23.561,0,0,0,1.97-10.771h2.338a1.412,1.412,0,0,1,1.394,1.637Z",
    transform: "translate(-68.876 0)",
    fill: "#3c3b41"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrowthCup);
export default __webpack_public_path__ + "static/media/growth-cup.0d8831b31254d3368c9b3d713290b66e.svg";
export { ForwardRef as ReactComponent };